
import VeryTopNavbar from "@/components/common/veryTopNavbar"
import ExamResultMainView from "./view"
import { useEffect, useState } from "react"
import { getResultApiCall } from "@/services/api"
import { useLocation } from "react-router-dom";

import RightAnswerIcon from "@/assets/icons/rightAnswer.png"
import WrongAnswerIcon from "@/assets/icons/wrongAnswer.png"
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

export default function ExamResultMain() {
    const location = useLocation();
    const { topSafeComponent } = useSafeAreaInsets();
    const [isLoading, setIsLoading] = useState(true)
    const [resultDetails, setResultDetails] = useState<any>({})
    const [attempts, setAttempts] = useState<any>([])

    const purchaseId = location.state?.purchaseId; // for test this is known as :: testExamDocId
    const currentExamType = location.state?.examType;


    // ----- START STATES : for pagination
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    
    const totalPages = Math.ceil(
        attempts.filter((attempt: any) => attempt.selectedOption !== null).length / pageSize
    );
    

    const paginatedAttempts = attempts.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );
    // ----- END STATES : for pagination


    // ----- START LOGIC : for pagination
    useEffect(() => {
        if (attempts.length > 0) {
            setCurrentPage(1);
        }
    }, [attempts]);

    // Clamp currentPage if questions shrink
    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage]);
    // ----- END LOGIC : for pagination


    useEffect(() => {
        initPage()
    }, [purchaseId])

    const initPage = async () => {
        const getResultApiCallStatus = await getResultApiCall(purchaseId, currentExamType)
        // console.log(getResultApiCallStatus)
        if (getResultApiCallStatus.status
            && getResultApiCallStatus.data
            && getResultApiCallStatus.data.attempts
            && getResultApiCallStatus.data.attempts.length > 0) {
            setResultDetails(getResultApiCallStatus.data)
            setAttempts(getResultApiCallStatus.data.attempts)
            setIsLoading(false)
        }
    }


    const isTheSelectedAnswerRight = (questionData: any, option: any) => {
        let ret = 0 // 0 : no action, 1 right answer, 2 wrong answer
        if (questionData.selectedOption === option) {
            if (questionData.answer === questionData.selectedOption) {
                ret = 1
            } else {
                ret = 2
            }
        }
        return ret
    }

    const getBackGroundColorForOption = (questionData: any, option: any) => {
        let color = "white"
        const isTheSelectedAnswerRight_ = isTheSelectedAnswerRight(questionData, option)
        if (isTheSelectedAnswerRight_ === 1) {
            color = "#e6ffe5" // green
        } else if (isTheSelectedAnswerRight_ === 2) {
            color = "#ffe5e5" // red
        }
        return color
    }

    const rightAnsWrongAnsIcon = (questionData: any, option: any) =>{
        let icon = null
        const isTheSelectedAnswerRight_ = isTheSelectedAnswerRight(questionData, option)
        if (isTheSelectedAnswerRight_ === 1) {
            icon = RightAnswerIcon
        } else if (isTheSelectedAnswerRight_ === 2) {
            icon = WrongAnswerIcon
        }
        return icon
 
    }


    return (
        <>
            <div className="font-roboto">
                {topSafeComponent}
                <VeryTopNavbar
                    showAlways={true}
                />

                <ExamResultMainView
                    isLoading={isLoading}
                    resultDetails={resultDetails}
                    // ----- START STATES : for pagination
                    attempts={paginatedAttempts}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                    // ----- END : for pagination

                    getBackGroundColorForOption={getBackGroundColorForOption}
                    rightAnsWrongAnsIcon={rightAnsWrongAnsIcon}

                />
            </div>
        </>
    )
}
